import { Navigate, useParams } from 'react-router-dom';

/**
 * /success/:id é mantida só como alias de back-compat — o fluxo cerimonial
 * de "presença eternizada" agora é exibido inline em /minha-colecao?just=:id.
 */
export default function Success() {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={id ? `/minha-colecao?just=${id}` : '/minha-colecao'} replace />;
}
